import WelcomePage from "../components/WelcomePage";

const HomePage = () => {
  return <WelcomePage />
};

export default HomePage;
